import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgVersterken = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M16.5 11.5H12.5V7.5C12.5 7.22 12.28 7 12 7C11.72 7 11.5 7.22 11.5 7.5V11.5H7.5C7.22 11.5 7 11.72 7 12C7 12.28 7.22 12.5 7.5 12.5H11.5V16.5C11.5 16.78 11.72 17 12 17C12.28 17 12.5 16.78 12.5 16.5V12.5H16.5C16.78 12.5 17 12.28 17 12C17 11.72 16.78 11.5 16.5 11.5Z' />
    <path d='M12 1.5C6.21 1.5 1.5 6.21 1.5 12C1.5 17.79 6.21 22.5 12 22.5C17.79 22.5 22.5 17.79 22.5 12C22.5 6.21 17.79 1.5 12 1.5ZM12 21.5C6.76 21.5 2.5 17.24 2.5 12C2.5 6.76 6.76 2.5 12 2.5C17.24 2.5 21.5 6.76 21.5 12C21.5 17.24 17.24 21.5 12 21.5Z' />
  </svg>
);
export default SvgVersterken;
